import { useEffect } from 'react';
import { useState, useCallback, useContext } from 'react'
import { DebounceInput } from 'react-debounce-input'
import { toDisplayString, specificityList } from '../../model/specificity';
import { TableStateContext } from '../../model/table_state_context';
import { useSearchParams } from 'react-router-dom';
import RecentlyViewed from './recently_viewed';

const initialSpecificity = specificityList.reduce((acc, spec) => ({ ...acc, [spec]: true }), {});

const specificityAsArray = (specMap) => Object.keys(specMap).filter((spec) => specMap[spec]);

// onChange should be a function expecting two arguments:
// 1. the search string
// 2. an object specifying which specificities should be included in the search results
//	e.g. onChange("polycer", { 'species': true, 'genus': false, 'family': true })
export default function TargetlistSearch() {

    const [searchParams, setSearchParams] = useSearchParams();
    const { setStartSearchForString, startSearchForString, searchResults } = useContext(TableStateContext);
    const [recentlyViewed, setRecentlyViewed] = useState([]);
    const [specificityValue, setSpecificityValue] = useState(initialSpecificity);
    const [listSearchResults, setListSearchResults] = useState([]);
    var filters = document.getElementById("tl-search-filter-container");
    var results = document.getElementById("tl-search-filter-results");

    useEffect(() => {
        const localStorageRecentlyViewd = localStorage.getItem('arise-targetlist-recently-viewed')
        if (localStorageRecentlyViewd) {
            setRecentlyViewed(JSON.parse(localStorageRecentlyViewd));
        }
    }, [])
    useEffect(() => {
        if (recentlyViewed) {
            localStorage.setItem('arise-targetlist-recently-viewed', JSON.stringify(recentlyViewed));
        }
    }, [recentlyViewed])

    const changeValue = useCallback((event) => {
        // setSearchValue(event.target.value);
        setStartSearchForString(event.target.value, specificityAsArray(specificityValue));
        if (event.target.value === null || event.target.value === "") {
            filters?.classList.remove("show");
            results?.classList.remove("show");
        }
    }, [setStartSearchForString, specificityValue, filters, results])

    const searchFor = useCallback(({ title, taxonomy }) => {
        // newest one on top of the list, and filter from old list if it is already there
        setRecentlyViewed(old => [{ title, taxonomy }, ...old.filter(item => item.title !== title || item.taxonomy !== taxonomy)])
        setSearchParams({ q: title, showfrom: taxonomy })
    }, [setSearchParams, setRecentlyViewed]);


    useEffect(() => {
        let newList = {};
        let hasAny = false;
        Object.entries(searchResults).forEach(([specificity, value]) => {
            if (value.count > 0 && specificityValue[specificity]) {
                newList[`${specificity} ${value.count}`] = value.items.map(item => ({ label: item, onClick: () => searchFor({ title: item, taxonomy: specificity }) }));
                hasAny = true;
            }
        });
        console.log(Object.keys(newList));
        if (hasAny) {
            filters?.classList.add("show");
            results?.classList.add("show");
        } else {
            if (Object.keys(newList).length > 0) {
                filters?.classList.remove("show");
                results?.classList.remove("show");
            }
        }
        setListSearchResults(newList);

    }, [searchResults, specificityValue, setSearchParams, filters, results, searchFor])

    const toggleSpecificity = useCallback((event) => {
        const { value, checked } = event.target;
        setSpecificityValue(old => ({ ...old, [value]: checked }));
        setStartSearchForString(startSearchForString, specificityAsArray({ ...specificityValue, [value]: checked }))
    }, [setSpecificityValue, startSearchForString, setStartSearchForString, specificityValue]);

    return (
        <div className="tl-search-main">
            <div className="tl-search-inner">
                <div className="tl-search-top">
                    <h3>Search</h3>
                    <div className="tl-search-container">
                        <div className="tl-search-box" tabIndex="0">
                            <DebounceInput
                                type="search"
                                value={startSearchForString}
                                debounceTimeout={400}
                                onChange={changeValue}
                                placeholder={`Search taxons`}
                                minLength={2}
                                id="tl-search"
                            // list={column.id + 'list'}
                            />
                            <div className="tl-search-filter-container" id="tl-search-filter-container">
                                {Object.keys(specificityValue).map((spec, idx) =>
                                    <div key={idx} className="tl-search-filter">
                                        <input type="checkbox" value={spec} disabled={searchResults[spec] ? searchResults[spec].items.length === 0 : false} onChange={(ev) => toggleSpecificity(ev)} defaultChecked={specificityValue[spec]} />
                                        <label key={idx}>
                                            {toDisplayString(spec)}
                                        </label>
                                    </div>
                                )}
                            </div>
                            <ul className="tl-search-filter-results" id="tl-search-filter-results">
                                {Object.entries(listSearchResults).map(([key, items], idx) =>
                                    <li key={idx}>
                                        {key}
                                        <ul className="tl-search-filter-result-categories">{items.map((item, idx2) =>
                                            <li key={idx2}><button onClick={item.onClick}>{item.label}</button></li>
                                        )}</ul>
                                    </li>)}
                            </ul>
                        </div>
                    </div>

                </div>
                <RecentlyViewed onChange={searchFor} recentlyViewed={recentlyViewed} />
            </div>
        </div>)
}